<template>
  <v-container style="margin-top:-20px;">
    <v-row>
      <v-col cols="12">
        <h2 class="mb-4">Impressum</h2>
        <v-card >
          <v-card-text>
            <h3>Anbieter im Sinne des TMG</h3>
            <p>
              Tobias Hubold<br>
              GS: Thomas-Mann-Straße 27 | 07743 Jena<br>
              E-Mail: hello(at)para-finder.de<br>
            </p>
            <p>
              Plattform der EU-Kommission zur Online-Streitbeilegung: 
              <a href="https://ec.europa.eu/odr" target="_blank" rel="noopener">https://ec.europa.eu/odr</a><br>
              Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle nicht verpflichtet, hierzu jedoch grundsätzlich bereit.
            </p>
            <p>
              Autor und Verantwortlicher i.S.d. § 55 Abs. 2 RStV: Tobias Hubold
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>
